import ticketBR from './ticket.br';
import ticketCL from './ticket.cl';
import ticketCO from './ticket.co';
import ticketMX from './ticket.mx';
import ticketES from './ticket.es';

const locales = {
  BR: ticketBR,
  CL: ticketCL,
  CO: ticketCO,
  MX: ticketMX,
  ES: ticketES,
};

export default locales;
